'use client'

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import JobModal from './job-modal';
import NoData from '../individual-components/no-data/page';

const JobsSection = ({ context, jobsList }) => {

    const [showMore, setShowMore] = useState(false)
    const [jobData, setJobData] = useState(null)
    const onClose = () => setJobData(null)

    const length = jobsList?.length

    return (
        <section className="relative flex flex-col items-start justify-center mt-16 w-full gap-8 px-4 mx-auto md:mb-28 mb-16 last:mb-10 xl:px-0 max-w-7xl">
            <h1 className="max-w-3xl text-black mx-auto md:mb-4 font-bold leading-10 md:text-center text-[30px] mb-3s text-left">
                {context?.header}
            </h1>

            <div className="w-full mb-8 h-[25rem] rounded-3xl">
                <img
                    alt="cover"
                    className="object-cover object-center w-full h-full rounded-3xl"
                    src="/images/Image.jpg"
                />
            </div>

            {
                length ?
                    <div className='flex flex-col items-start justify-center gap-8'>
                        <div className="relative flex flex-wrap items-stretch justify-center w-full gap-x-10 gap-y-6 mb-4">
                            {jobsList?.slice(0, showMore ? length + 1 : 9)?.map((job, i) => (
                                <JobCard key={job?.requisitionId} category={job?.skillCategoryResponse?.length ? job?.skillCategoryResponse[0]?.name : job?.jobTitle} {...job} onClick={() => setJobData(job)} />
                            ))}
                        </div>

                        <div className='mx-auto'>
                            <button
                                className='bg-[#EB532E] cursor-pointer font-semibold relative text-center mx-auto text-white py-3.5 px-6 rounded-full hover:underline transition-all duration-300 hover:bg-[#b33313]'
                                onClick={() => setShowMore(state => !state)}
                            >
                                See {showMore ? "Less" : "More"}
                            </button>
                        </div>

                        {jobData && <JobModal jobData={jobData} onClose={onClose} />}
                    </div> :
                    <NoData heading='No jobs found' />

            }
        </section>
    );
};


const JobCard = (props) => {

    const {
        category,
        jobTitle,
        minExp,
        maxExp,
        employmentTypeName,
        skills,
        location,
        onClick
    } = props

    return (
        <div onClick={onClick} className="w-full flex flex-col cursor-pointer group transition-all duration-300 p-6 shadow-xl border rounded-2xl max-w-[400px] bg-white hover:bg-[#EB532E] hover:shadow-2xl job-card">
            <div className="flex gap-2 items-start justify-between w-full mb-1">
                <div className="w-full font-semibold text-sm text-[#EB532E] group-hover:text-white transition-all duration-300">
                    {category}
                </div>
                <div>
                    <svg className="stroke-[#EB532E] group-hover:stroke-white transition-all duration-300" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.3333 5.66667L16.5 1.5M16.5 1.5H12.3333M16.5 1.5V5.66667M5.66667 5.66667L1.5 1.5M1.5 1.5L1.5 5.66667M1.5 1.5L5.66667 1.5M5.66667 12.3333L1.5 16.5M1.5 16.5H5.66667M1.5 16.5L1.5 12.3333M12.3333 12.3333L16.5 16.5M16.5 16.5V12.3333M16.5 16.5H12.3333" stroke="current" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                </div>
            </div>

            <div className="w-full mb-4 font-semibold text-black leading-normal transition-all duration-300 text-lg group-hover:text-white">
                {jobTitle}
            </div>

            <div className="flex xs:flex-col xs:gap-1 xs:mb-4 items-start w-full gap-6">
                <div className="relative w-fit font-semibold flex gap-2.5 text-base text-secondary group-hover:text-white transition-all duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className='w-5 h-5' viewBox="0 0 24 24">
                        <path fill="#454545" className='group-hover:fill-white transition-all duration-300' d="M19 6h-3V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3m-9-1h4v1h-4Zm10 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5.61L8.68 14A1.2 1.2 0 0 0 9 14h6a1.2 1.2 0 0 0 .32-.05L20 12.39Zm0-7.72L14.84 12H9.16L4 10.28V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" />
                    </svg>
                    <span>{minExp}+ year of experience</span>
                </div>
                <div className="relative w-fit font-semibold flex gap-2.5 text-base text-secondary group-hover:text-white transition-all duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className='w-5 h-5 mt-[1px] ' viewBox="0 0 24 24">
                        <g fill="none" stroke="#454545" className='group-hover:stroke-white transition-all duration-300' strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0" /><path d="M12 7v5l3 3" />
                        </g>
                    </svg>
                    <span>{employmentTypeName}</span>
                </div>
            </div>

            <div className="relative w-full flex-auto text-secondary text-base mb-4 group-hover:text-white transition-all duration-300 break-word">
                {skills}
            </div>

            <div className="flex items-start w-full gap-6">
                <div className="relative w-fit font-semibold flex gap-2.5 text-base text-secondary group-hover:text-white transition-all duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 ' viewBox="0 0 24 24">
                        <g fill="none" stroke="#454545" className='group-hover:stroke-white transition-all duration-300' strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                            <path d="M12.56 20.82a.96.96 0 0 1-1.12 0C6.611 17.378 1.486 10.298 6.667 5.182A7.6 7.6 0 0 1 12 3c2 0 3.919.785 5.333 2.181c5.181 5.116.056 12.196-4.773 15.64" /><path d="M12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4" />
                        </g>
                    </svg>
                    {location}
                </div>
            </div>
        </div>
    );
};

JobCard.propTypes = {
    category: PropTypes.string.isRequired,
    jobTitle: PropTypes.string.isRequired,
    minExp: PropTypes.string.isRequired,
    employmentTypeName: PropTypes.string.isRequired,
    skills: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired
}

export default JobsSection;